/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_BOX_LIST = gql`
  query GetUsersWithBoxes(
    $options: GetManyOptions
    $filters: UserAndBoxAggFilterInput
  ) {
    getUsersWithBoxes(options: $options, filters: $filters) {
      count
      limit
      skip
      content {
        email
        firstName
        fullName
        image
        lastName
        _box {
          activeStatus {
            status
          }
          id
          comments
          contentStatus
          costumeID
          createdAt
          deliveryStatus
          description
          gender
          isVIP
          masqID
          paymentStatus
          shelf {
            name
            shelfId
          }
          user {
            fullName
            email
            image
            firstName
            lastName
            id
            emailVerified
          }
        }
      }
    }
  }
`;
